import { render, staticRenderFns } from "./CalendarHeatmap.vue?vue&type=template&id=5c510f2c&scoped=true&"
import script from "./CalendarHeatmap.vue?vue&type=script&lang=js&"
export * from "./CalendarHeatmap.vue?vue&type=script&lang=js&"
import style0 from "./CalendarHeatmap.vue?vue&type=style&index=0&id=5c510f2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c510f2c",
  null
  
)

export default component.exports